import type { AppConfig } from '@/types/sentryConfigTypes';

export function getAppConfig(): AppConfig | undefined {
  return (window as Window & { __APP_CONFIG__?: AppConfig }).__APP_CONFIG__;
}
